module.exports = __webpack_public_path__ + "static/map_eng-bf14c9abd7a0af97ec451c2143a76ea3.png";